module.exports = __webpack_public_path__ + "img/2.04.thmb.xs.2debd722.jpg";